<script>
    import {GA_IDENTIFIER} from '$lib/svelte_1848_settings.js';
    import {page} from '$app/stores';

    export let title;
    export let publication_date = '';
    export let modified = '';
    export let description = '';
</script>

<svelte:head>
    <title>{title}</title>
    {#if $page.url.host == '1848.nl'}
        <link rel="manifest" href="/site-landing.webmanifest">
    {:else if $page.url.host == 'app.1848.nl'}
        <link rel="manifest" href="/site.webmanifest">
    {/if}
    <link rel="apple-touch-icon" sizes="180x180" href="https://{$page.url.host}/apple-touch-icon.png">
    <link rel="icon" type="image/png" sizes="32x32" href="https://{$page.url.host}/favicon-32x32.png">
    <link rel="icon" type="image/png" sizes="16x16" href="https://{$page.url.host}/favicon-16x16.png">
    <link rel="mask-icon" href="https://{$page.url.host}/safari-pinned-tab.svg" color="#e9f8ff">
    <meta name="msapplication-TileColor" content="#e9f8ff">
    <meta name="theme-color" content="#e9f8ff">
    <meta property="og:title" content="{title}">
    <meta property="og:url" content="{$page.url}">
    <meta property="og:type" content="article">
    <meta property="og:image" content="https://{$page.url.host}/1848-open-graph.jpg">
    <meta property="og:image:width" content="1500">
    <meta property="og:image:height" content="500">
    <meta property="twitter:image" content="https://{$page.url.host}/1848-blue.png">
    <meta name="twitter:card" content="summary">
    <meta name="twitter:site" content="@1848nl_sv">
    <meta name="twitter:creator" content="@1848nl_sv">
    {#if description}
        <meta property="article:published_time" content="{publication_date}">
        <meta property="article:modified_time" content="{modified}">
        <meta name="description" content="{description.replace('&hellip;', '...')}">
        <meta property="og:description" content="{description.replace('&hellip;', '...')}">
    {:else}
        <meta name="description" content="De politieke monitor voor doorzoeken, realtime monitoring en directe notificaties van stukken van de Tweede Kamer, Eerste Kamer en het Europees Parlement, zoals Kamerbrieven, Kamervragen en wetsvoorstellen.">
    {/if}
    <!-- Global site tag (gtag.js) - Google Analytics -->
    <link rel="preconnect" href="https://www.google-analytics.com/">
    <script async src='https://www.googletagmanager.com/gtag/js?id={GA_IDENTIFIER}'></script>
    {@html `<script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_IDENTIFIER}', {
          cookie_flags: 'max-age=7200;secure;samesite=none',
          anonymize_ip: true
      });
    </script>`}
</svelte:head>
